import { PLANET_GLYPHS, PLANET_EN_ES, SIGN_EN_ES, ZODIAC_GLYPHS } from "./api";

const W = 1080, H = 1920;
const GOLD = "#C9A25E", PLUM = "#3A2249";
const SERIF = "'Cormorant Garamond', serif", SANS = "Outfit, sans-serif";
const STYLE_PROPS = ["fill", "stroke", "stroke-width", "stroke-dasharray", "opacity", "fill-opacity",
  "stroke-opacity", "font-family", "font-size", "font-weight", "text-anchor", "dominant-baseline"];

function svgToImage(svgEl, size) {
  const clone = svgEl.cloneNode(true);
  const src = svgEl.querySelectorAll("*"), dst = clone.querySelectorAll("*");
  src.forEach((el, i) => {
    const cs = getComputedStyle(el);
    dst[i].setAttribute("style", STYLE_PROPS.map((p) => `${p}:${cs.getPropertyValue(p)}`).join(";"));
  });
  clone.setAttribute("xmlns", "http://www.w3.org/2000/svg");
  clone.setAttribute("width", size);
  clone.setAttribute("height", size);
  const url = URL.createObjectURL(new Blob([new XMLSerializer().serializeToString(clone)], { type: "image/svg+xml" }));
  return new Promise((res, rej) => {
    const img = new Image();
    img.onload = () => { URL.revokeObjectURL(url); res(img); };
    img.onerror = rej;
    img.src = url;
  });
}

function background(ctx) {
  ctx.fillStyle = "#06060C";
  ctx.fillRect(0, 0, W, H);
  const g = ctx.createRadialGradient(W / 2, 720, 40, W / 2, 720, 760);
  g.addColorStop(0, "rgba(58,34,73,0.75)");
  g.addColorStop(1, "rgba(6,6,12,0)");
  ctx.fillStyle = g;
  ctx.fillRect(0, 0, W, H);
  for (let i = 0; i < 220; i++) {
    ctx.fillStyle = i % 6 === 0 ? "rgba(201,162,94,0.7)" : "rgba(183,155,199,0.45)";
    ctx.beginPath();
    ctx.arc((i * 7919) % W, (i * 104729) % H, i % 9 === 0 ? 1.8 : 1, 0, Math.PI * 2);
    ctx.fill();
  }
  ctx.strokeStyle = "rgba(201,162,94,0.35)";
  ctx.lineWidth = 2;
  ctx.strokeRect(40, 40, W - 80, H - 80);
}

function text(ctx, str, x, y, font, color, align = "center") {
  ctx.font = font;
  ctx.fillStyle = color;
  ctx.textAlign = align;
  ctx.fillText(str, x, y);
}

function spaced(str) { return str.toUpperCase().split("").join("\u200A"); }

function positions(chart) {
  const rows = chart.planets.map((p) => ({
    glyph: PLANET_GLYPHS[p.planet], name: PLANET_EN_ES[p.planet] + (p.retrograde ? " ℞" : ""),
    sign: p.sign, degree: p.degree, house: p.house,
  }));
  rows.push({ glyph: "AC", name: "Ascendente", sign: chart.ascendant.sign, degree: chart.ascendant.degree });
  rows.push({ glyph: "MC", name: "Medio Cielo", sign: chart.midheaven.sign, degree: chart.midheaven.degree });
  return rows;
}

function drawPositions(ctx, chart, top) {
  const rows = positions(chart);
  const half = Math.ceil(rows.length / 2), colW = 470, rowH = 78;
  rows.forEach((r, i) => {
    const col = i < half ? 0 : 1, x = 80 + col * (colW + 40), y = top + (i % half) * rowH;
    text(ctx, r.glyph, x + 20, y, `34px ${SERIF}`, GOLD);
    text(ctx, r.name, x + 56, y - 4, `28px ${SANS}`, "#FAFAFA", "left");
    const detail = `${ZODIAC_GLYPHS[r.sign]} ${SIGN_EN_ES[r.sign]} ${Math.floor(r.degree)}°${r.house ? ` · Casa ${r.house}` : ""}`;
    text(ctx, detail, x + 56, y + 30, `22px ${SANS}`, "#A1A1AA", "left");
  });
}

export async function buildChartImage({ svgEl, chart, name, birthLine, brand }) {
  await document.fonts.ready;
  const cv = document.createElement("canvas");
  cv.width = W; cv.height = H;
  const ctx = cv.getContext("2d");
  background(ctx);
  text(ctx, spaced(brand), W / 2, 140, `26px ${SANS}`, GOLD);
  text(ctx, "Carta natal", W / 2, 230, `italic 64px ${SERIF}`, "#E4E4E7");
  text(ctx, name, W / 2, 315, `300 84px ${SERIF}`, "#FFFFFF");
  text(ctx, birthLine, W / 2, 370, `24px ${SANS}`, "#A1A1AA");
  const wheel = await svgToImage(svgEl, 720);
  ctx.drawImage(wheel, (W - 720) / 2, 410, 720, 720);
  ctx.strokeStyle = "rgba(201,162,94,0.4)";
  ctx.beginPath(); ctx.moveTo(W / 2 - 120, 1175); ctx.lineTo(W / 2 + 120, 1175); ctx.stroke();
  drawPositions(ctx, chart, 1245);
  ctx.fillStyle = PLUM;
  ctx.fillRect(40, H - 150, W - 80, 110);
  text(ctx, "Calcula la tuya gratis en", W / 2, H - 103, `22px ${SANS}`, "#D4D4D8");
  text(ctx, "eterea-enlace.com", W / 2, H - 62, `600 32px ${SANS}`, GOLD);
  return new Promise((res) => cv.toBlob(res, "image/png"));
}

export async function shareOrDownload(blob, filename) {
  const file = new File([blob], filename, { type: "image/png" });
  if (navigator.canShare?.({ files: [file] }) && /Android|iPhone|iPad/i.test(navigator.userAgent)) {
    try { await navigator.share({ files: [file], title: "Mi carta natal" }); return; } catch (e) {
      if (e?.name === "AbortError") return;
    }
  }
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = filename;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
